import React, { ChangeEvent } from "react";
import {
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { FastField, useField, useFormikContext } from "formik";

export type Option = { [key: string]: string } | string;

interface SelectDropDown {
  fieldname: string;
  label: string;
  options: Option[];
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  displayErr?: boolean;
  multiple?: boolean;
  value?: any;
}

const SelectDropDown = (props: SelectDropDown) => {
  const { label, fieldname, options, disabled, displayErr, multiple } = props;
  let propsCopy = { ...props };
  useFormikContext();
  const [field, meta] = useField(fieldname);
  const { setFieldTouched } = useFormikContext();

  const handleBlur = (event: ChangeEvent<HTMLInputElement>) => {
    setFieldTouched(field.name, true);
  };

  if (!disabled) {
    delete propsCopy.disabled;
  }

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel disabled={disabled} id={fieldname}>
        {label}
      </InputLabel>
      <FastField
        as={Select}
        multiple={multiple}
        onTouch={handleBlur}
        error={(meta.touched || displayErr) && meta.error}
        helperText={meta.touched && meta.error ? meta.error : ""}
        name={fieldname}
        labelId={fieldname}
        variant="outlined"
        {...propsCopy}
      >
        {options && options.length ? (
          options.map((option: Option, idx: number) => {
            if (typeof option === "string") {
              return (
                <MenuItem key={idx} value={option} disabled={disabled}>
                  {option}
                </MenuItem>
              );
            } else {
              return (
                <MenuItem
                  disabled={disabled}
                  key={idx}
                  value={Object.keys(option)[0]}
                >
                  {Object.values(option)[0]}
                </MenuItem>
              );
            }
          })
        ) : (
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
        )}
      </FastField>
      <FormHelperText error>
        {(meta.touched || displayErr) && meta.error ? meta.error : ""}
      </FormHelperText>
    </FormControl>
  );
};

export default SelectDropDown;
